module.exports = __webpack_public_path__ + "static/media/small_photo.cb1791a7.jpg";